'use client'

import { TypographyStringType } from './Typography'

/**
 * Client-safe plain-string typography for use inside client components (e.g. AchieveLink).
 * For rich text or server-rendered content, use Typography or TypographyLongForm instead.
 */
function TypographyString({
  content,
  variantOverride,
  mobileVariantOverride,
  styleOverride,
  mobileVariant,
  breakpoint,
  responsive,
  ...props
}) {
  if (typeof content !== 'string') {
    return null
  }

  return TypographyStringType({
    styleOverride,
    variantOverride,
    mobileVariantOverride,
    typographyContent: content,
    mobileVariant,
    breakpoint,
    responsive,
    props,
  })
}

export { TypographyString }
export default TypographyString
